import { useEffect, useState } from 'react';

import { isEqualWith } from 'lodash-es';

import { and, debounce, propEq } from '../utils';

interface Dimensions {
  innerHeight: number;
  innerWidth: number;
}

const dims = ({ innerHeight, innerWidth }: Dimensions) => ({ innerHeight, innerWidth });
const sameHeight = propEq<Dimensions, 'innerHeight'>('innerHeight');
const sameWidth = propEq<Dimensions, 'innerWidth'>('innerWidth');
const sameDimensions = and(sameHeight, sameWidth);

const dimensionsHaveChanged = (prev: Dimensions, next: Dimensions) =>
  !isEqualWith(prev, next, sameDimensions);

/**
 * Watches the document and returns its demensions when it changes.
 */
export const useWindowResize = () => {
  const [dimensions, setDimensions] = useState(dims(window));

  useEffect(() => {
    const handleResize = debounce(() => {
      if (dimensionsHaveChanged(dimensions, window)) {
        setDimensions(dims(window));
      }
    }, 100);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dimensions]);

  return { dimensions };
};
